import "./globals.js";

import { createIcons, icons } from "lucide";

import Quill from "quill";
import { jobTpl } from "./utils.js";

const postJobform = $("#postJobform");
const formFields = {
	jobCountry: $("#job_country"),
	jobCompanyName: $("#job_company_name"),
	jobCompanyLogo: $("#job_company_logo"),
	jobCompanyCity: $("#job_company_city"),
	jobTitle: $("#job_title"),
	jobDescription: $("#job_description"),
	jobMinSalary: $("#job_min_salary"),
	jobMaxSalary: $("#job_max_salary"),
	jobCurrency: $("#job_currency"),
	jobSalaryTime: $("#job_salary_time"),
	jobHours: $("#job_hours"),
	jobApplicationUrl: $("#job_application_url"),
	jobEducation: $("#job_education"),
	invoiceCompanyName: $("#invoice_company_name"),
	invoiceCompanyId: $("#invoice_company_id"),
	invoiceCompanyVat: $("#invoice_company_vat"),
	invoiceCompanyCountry: $("#invoice_country"),
	invoiceCompanyAddress1: $("#company_address_1"),
	invoiceEmail: $("#invoice_email"),
};

const step1 = $("#step1");
const step2 = $("#step2");
const previousStep = $("#gotoStep1");
const nextStep = $("#gotoStep2");
const submitButton = $("#submitButton");
const freeJobPost = $("#freeJobPost");

// tags
const MAX_TAGS = 7;
const newTag = $("#job_tags_input");
const tagInput = $("#job_tags");
const allTags = $(".tags");
const addTag = $("#addTag");

const validateEmail = (email) => {
	const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return regex.test(email);
};

const validateUrl = (url) => {
	try {
		const parsedUrl = new URL(url);
		// only http and https are allowed
		return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
	} catch (e) {
		return false;
	}
};

const validateRequired = (input) => {
	if (input.value.trim() === "") {
		return `${input.placeholder || input.ariaPlaceholder} is required!`;
	}
	return "";
};

// scroll to top form
const scrollToForm = () => {
	requestAnimationFrame(() => {
		postJobform.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	});
};

const showErrorOnInput = (input, validatorMsg) => {
	const formHelper = $(`#${input.getAttribute("aria-describedby")}`);

	formHelper.innerHTML = validatorMsg;
	input.setAttribute("aria-invalid", "true");
};

const removeErrorOnInput = (input) => {
	const formHelper = $(`#${input.getAttribute("aria-describedby")}`);

	formHelper.innerHTML = "";
	input.removeAttribute("aria-invalid");
};

const validateFormItem = (input, validator) => {
	const validatorMsg = validator(input);

	if (validatorMsg) {
		return showErrorOnInput(input, validatorMsg);
	}
	return removeErrorOnInput(input);
};

// check first error from form(part)
const hasFormError = (formPart) => {
	return Array.from(formPart.querySelectorAll("small[id]")).find(
		(small) => small.textContent.trim() !== "",
	);
};

// fetch free jobpost
const fetchFreeJobposts = async () => {
	const freeAmount = $("#freeAmount"); // check if exists
	const freeAmountLabel = $("#freeAmountLabel");
	const freeAmountMsg = $("#freeAmountMsg");

	try {
		const response = await fetch(freeJobPost.dataset.url);
		const jobLisnrOfFreePost = await response.json();
		const nrOfFreeJobsLeft = Number.parseInt(jobLisnrOfFreePost.free);
		freeJobPost.innerHTML = jobLisnrOfFreePost.free;

		if (freeAmount) {
			if (nrOfFreeJobsLeft === 0) {
				freeAmountLabel.setAttribute("aria-disabled", true);
				freeAmount.setAttribute("disabled", "");
				freeAmountMsg.innerHTML = "No free post left for today!";
			} else {
				freeAmount.removeAttribute("disabled");
				freeAmountLabel.removeAttribute("aria-disabled");
				freeAmountMsg.innerHTML = `FREE, still ${nrOfFreeJobsLeft} ${nrOfFreeJobsLeft === 1 ? "post" : "posts"} available for today!`;
			}
		}
	} catch (e) {
		if (freeAmount) {
			freeAmountLabel.setAttribute("aria-disabled", true);
			freeAmount.setAttribute("disabled", "");
			freeAmountMsg.innerHTML = "No free post left for today!";
		}
		console.error(e);
	}
};

// poll free jobposts
const setIntervalFreeJobPosts = () => {
	setInterval(fetchFreeJobposts, 3000);
};

// next step
if (nextStep) {
	nextStep.addEventListener("click", (e) => {
		e.preventDefault();

		// STEP 1 validators
		validateFormItem(formFields.jobCountry, validateRequired);
		validateFormItem(formFields.jobCompanyCity, validateRequired);
		validateFormItem(formFields.jobCompanyName, validateRequired);
		validateFormItem(formFields.jobTitle, validateRequired);

		// salary check if filled
		removeErrorOnInput(formFields.jobMaxSalary);
		if (
			formFields.jobMinSalary.value &&
			formFields.jobMaxSalary.value &&
			Number.parseInt(formFields.jobMinSalary.value) >
				Number.parseInt(formFields.jobMaxSalary.value)
		) {
			showErrorOnInput(
				formFields.jobMaxSalary,
				"Maximum salary must be higher than minimal salary.",
			);
		}

		// if salary is filled, currency is required
		removeErrorOnInput(formFields.jobCurrency);
		if (
			(formFields.jobMinSalary.value || formFields.jobMaxSalary.value) &&
			formFields.jobCurrency.value === ""
		) {
			showErrorOnInput(
				formFields.jobCurrency,
				"Currency is required, if salary is specified.",
			);
		}

		// if salary is filled, job_salary_time is required
		removeErrorOnInput(formFields.jobSalaryTime);
		if (
			(formFields.jobMinSalary.value || formFields.jobMaxSalary.value) &&
			formFields.jobSalaryTime.value === ""
		) {
			showErrorOnInput(
				formFields.jobSalaryTime,
				"Job salary per time unit is required, if salary is specified.",
			);
		}

		// application URL of mail
		removeErrorOnInput(formFields.jobApplicationUrl);
		if (
			!validateEmail(formFields.jobApplicationUrl.value) &&
			!validateUrl(formFields.jobApplicationUrl.value)
		) {
			showErrorOnInput(
				formFields.jobApplicationUrl,
				"Job application must be valid email or URL.",
			);
		}

		// jobHours
		removeErrorOnInput(formFields.jobHours);
		if (
			formFields.jobHours.value.trim() !== "" &&
			formFields.jobHours.value > 40
		) {
			showErrorOnInput(formFields.jobHours, "Job hours cannot exceed 40.");
		}

		// company logo
		const validImgs = ["gif", "png", "jpg", "svg"];
		removeErrorOnInput(formFields.jobCompanyLogo);
		const lastPartLogo = formFields.jobCompanyLogo.value.includes(".")
			? formFields.jobCompanyLogo.value.split(".").pop().toLowerCase()
			: null;

		if (
			formFields.jobCompanyLogo.value.trim() !== "" &&
			(!validateUrl(formFields.jobCompanyLogo.value) ||
				!validImgs.includes(lastPartLogo))
		) {
			showErrorOnInput(
				formFields.jobCompanyLogo,
				`Logo must be valid logo URL, ending with ${validImgs.join(", ")}.`,
			);
		}

		// editor helper
		removeErrorOnInput(formFields.jobDescription);
		if (formFields.jobDescription.value.trim().length === 0) {
			showErrorOnInput(formFields.jobDescription, "This field is required!");
		}

		// if error scroll to error, else step2
		const formInputError = hasFormError(step1);

		if (formInputError) {
			step1.querySelector(`[aria-describedby="${formInputError.id}"]`).focus();
		} else {
			step1.classList.add("hidden");
			step2.classList.remove("hidden");
			scrollToForm();
		}
	});
}

// previous button
if (previousStep) {
	previousStep.addEventListener("click", (e) => {
		e.preventDefault();
		step1.classList.remove("hidden");
		step2.classList.add("hidden");
		scrollToForm();
	});
}

// last step step
if (submitButton) {
	submitButton.addEventListener("click", (e) => {
		e.preventDefault();

		validateFormItem(formFields.invoiceCompanyName, validateRequired);
		validateFormItem(formFields.invoiceEmail, validateRequired);
		validateFormItem(formFields.invoiceCompanyAddress1, validateRequired);

		removeErrorOnInput(formFields.invoiceEmail);
		if (!validateEmail(formFields.invoiceEmail.value)) {
			showErrorOnInput(
				formFields.invoiceEmail,
				"Invoice email address is required.",
			);
		}

		// logical invoice validators
		removeErrorOnInput(formFields.invoiceCompanyId);
		if (formFields.invoiceCompanyId.value.trim().length < 8) {
			showErrorOnInput(
				formFields.invoiceCompanyId,
				"Company ID must be at least 8 characters.",
			);
		}

		removeErrorOnInput(formFields.invoiceCompanyVat);
		if (formFields.invoiceCompanyVat.value.trim().length < 9) {
			showErrorOnInput(
				formFields.invoiceCompanyVat,
				"Company VAT ID must be at least 9 characters.",
			);
		}

		// if error scroll to error, else step2
		const formInputError = hasFormError(step2);

		if (formInputError) {
			step2.querySelector(`[aria-describedby="${formInputError.id}"]`).focus();
		} else {
			postJobform.submit();
		}
	});
}

// editor
const editor = $("#editor");
if (editor) {
	const quill = new Quill("#editor", {
		theme: "snow", // Snow theme for styling
		placeholder: "Start typing...",
		modules: {
			toolbar: [
				["bold", "italic", "underline"], // font options
				[{ list: "ordered" }, { list: "bullet" }], // Ordered and unordered lists
				["clean"], // Clear formatting
			],
		},
	});

	// copy change editor into form field
	quill.on("text-change", () => {
		const text = quill.root.innerHTML;
		const MAX_JOB_DESCRIPTION_SIZE = 5000;
		const jobDescriptionHelper = $("#helper_job_description");
		// max-length check
		if (text.length > MAX_JOB_DESCRIPTION_SIZE) {
			jobDescriptionHelper.classList.add("required");
			jobDescriptionHelper.innerHTML = `Maximum character of ${MAX_JOB_DESCRIPTION_SIZE} has been reached, please remove some text!`;
		} else {
			removeErrorOnInput(formFields.jobDescription);
			jobDescriptionHelper.classList.remove("required");
			jobDescriptionHelper.innerHTML = `${text.length} of ${MAX_JOB_DESCRIPTION_SIZE} characters.`;
		}

		// never exeeds MAX_JOB_DESCRIPTION_SIZE
		formFields.jobDescription.value = text.substring(
			0,
			MAX_JOB_DESCRIPTION_SIZE,
		);
	});
}

// TAGS logic
const setNrOfCurrentTags = () => {
	const nrOfCurrentTags = $("#nrOfCurrentTags");
	nrOfCurrentTags.innerHTML = tagInput.value
		? tagInput.value.split(",").length
		: 0;
};

const addTagRemoverClicks = () => {
	const allTagsRmBtns = $$("[data-tag-target-id]") || [];

	// first tag
	Array.from(allTagsRmBtns).map((tagRemoveBtn) => {
		tagRemoveBtn.addEventListener("click", (event) => {
			event.preventDefault();
			const tag = event.currentTarget.dataset.tagTargetId;
			const targetTag = $(`[data-tag-id="${tag}"]`);

			if (targetTag) {
				// remove tag
				targetTag.remove();

				// update list of tags
				tagInput.value = Array.from(tagInput.value.split(","))
					.filter((value) => value !== tag)
					.join(",");

				// enable fields
				if (tagInput.value.split(",").length < MAX_TAGS) {
					newTag.removeAttribute("disabled");
					addTag.removeAttribute("disabled");
				}
			}

			// update nr of tags
			setNrOfCurrentTags();
		});
	});
};

const renderTags = () => {
	const uniqueTags = [
		...new Set(
			tagInput.value
				.split(",")
				.map((item) => item.trim())
				.filter((item) => item !== ""),
		),
	];
	const tagTpl = (id) =>
		`<div class="tag" data-tag-id="${id}"><i data-lucide="x" data-tag-target-id="${id}" class="remove-tag"></i>${id}</div>`;
	allTags.innerHTML = uniqueTags.map((tag) => tagTpl(tag)).join("");

	// re-init icons
	createIcons({ icons });

	// init page
	addTagRemoverClicks();
	// set current nr of tags
	setNrOfCurrentTags();
};

// add tag
if (addTag) {
	addTag.addEventListener("click", (e) => {
		e.preventDefault();
		const tagHelper = $("#helper_job_tags_input");
		// check on empty
		if (newTag.value.trim() === "") return;

		const newTagValue = newTag.value.split(" ").join(","); // split space to commma

		// tag validator
		newTag.removeAttribute("aria-invalid");
		tagHelper.innerHTML = "";

		for (const tag of newTagValue.split(",")) {
			if (tag.trim().length > 20) {
				tagHelper.innerHTML = "Tag cannot exceed 20 characters!";
				newTag.setAttribute("aria-invalid", "true");
				return; // Exit the loop after finding the first long tag
			}
		}

		// detect nr of tags, and uniquenes
		const newTags = `${tagInput.value},${newTagValue}`;

		// make unique tags list
		const newTagsUniqueValues = [
			...new Set(
				newTags
					.split(",")
					.map((item) => item.trim())
					.filter((item) => item !== ""),
			),
		];

		if (newTagsUniqueValues.length <= MAX_TAGS) {
			tagInput.value = newTagsUniqueValues.join(","); // new tags
			newTag.value = ""; // reset input

			// render tags
			renderTags();
		}

		// first enable, if max, disable
		newTag.removeAttribute("disabled");
		addTag.removeAttribute("disabled");
		if (newTagsUniqueValues.length === MAX_TAGS) {
			newTag.setAttribute("disabled", true);
			addTag.setAttribute("disabled", true);
		}
	});
}
// INIT page
(() => {
	// if form is visible
	if (postJobform) {
		renderTags();
		fetchFreeJobposts();
		setIntervalFreeJobPosts();

		// set default countries
		// detect language and set default county
		formFields.jobCountry.value = navigator.language.slice(-2);

		// fallback selector to UK
		if (formFields.jobCountry.value === "") {
			formFields.jobCountry.value = "UK";
		}
		// prefill invoiceCompanyCountry
		formFields.invoiceCompanyCountry.value = formFields.jobCountry.value;

		// invoice amount prefilled, EURO, GBP, USD, FREE
		const invoiceCurrencySelector = $$('input[name="amount"]');
		switch (formFields.jobCountry.value) {
			case "UK":
				invoiceCurrencySelector[1].setAttribute("checked", "");
				break;
			case "US":
				invoiceCurrencySelector[2].setAttribute("checked", "");
				break;
			default:
				invoiceCurrencySelector[0].setAttribute("checked", "");
		}

		// MODAL
		// Config
		const isOpenClass = "modal-is-open";
		const openingClass = "modal-is-opening";
		const closingClass = "modal-is-closing";
		const scrollbarWidthCssVar = "--pico-scrollbar-width";
		const animationDuration = 400; // ms
		let visibleModal = null;

		$("#showJobPostExample").addEventListener("click", (e) => {
			e.preventDefault();

			const jobEntry = {
				title: formFields.jobTitle.value,
				company: formFields.jobCompanyName.value,
				logo: formFields.jobCompanyLogo.value,
				city: formFields.jobCompanyCity.value,
				currency: formFields.jobCurrency.value,
				min_salary: formFields.jobMinSalary.value,
				max_salary: formFields.jobMaxSalary.value,
				salary_time: formFields.jobSalaryTime.value,
				hours: formFields.jobHours.value,
				education: formFields.jobEducation.value,
				tags: tagInput.value.split(","),
			};
			const jobFooter = $("#jobPostExample");
			const jobCardFooter = `<footer>
							<button id="closeJobPostExample" data-target="jobPostExample">Confirm</button>
						</footer>`;
			const jobCardHTML = jobTpl(jobEntry, null, jobCardFooter);
			$("#jobPostExample").innerHTML = jobCardHTML;
			// re-init icons
			createIcons({ icons });

			const modal = document.getElementById(e.currentTarget.dataset.target);
			if (!modal) return;

			// add closing function
			$("#closeJobPostExample").addEventListener("click", (e) => {
				const modal = document.getElementById(e.currentTarget.dataset.target);
				if (!modal) return;
				closeModal(modal);
			});

			openModal(modal);
		});

		// Open modal
		const openModal = (modal) => {
			const { documentElement: html } = document;
			const scrollbarWidth = getScrollbarWidth();
			if (scrollbarWidth) {
				html.style.setProperty(scrollbarWidthCssVar, `${scrollbarWidth}px`);
			}
			html.classList.add(isOpenClass, openingClass);
			setTimeout(() => {
				visibleModal = modal;
				html.classList.remove(openingClass);
			}, animationDuration);
			modal.showModal();
		};

		// Close modal
		const closeModal = (modal) => {
			visibleModal = null;
			const { documentElement: html } = document;
			html.classList.add(closingClass);
			setTimeout(() => {
				html.classList.remove(closingClass, isOpenClass);
				html.style.removeProperty(scrollbarWidthCssVar);
				modal.close();
			}, animationDuration);
		};

		// Close with a click outside
		document.addEventListener("click", (event) => {
			if (visibleModal === null) return;
			const modalContent = visibleModal.querySelector("article");
			const isClickInside = modalContent.contains(event.target);
			!isClickInside && closeModal(visibleModal);
		});

		// Close with Esc key
		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape" && visibleModal) {
				closeModal(visibleModal);
			}
		});

		// Get scrollbar width
		const getScrollbarWidth = () => {
			const scrollbarWidth =
				window.innerWidth - document.documentElement.clientWidth;
			return scrollbarWidth;
		};

		// Is scrollbar visible
		const isScrollbarVisible = () => {
			return document.body.scrollHeight > screen.height;
		};
	}
	// prevent back to filled form here
	if ($(".success")) {
		window.addEventListener("popstate", (event) => {
			window.location.href = "/"; // Redirect to jobboard
		});
	}
})();
